import { render, staticRenderFns } from "./absent-list.vue?vue&type=template&id=72be6683&scoped=true&"
import script from "./absent-list.vue?vue&type=script&lang=js&"
export * from "./absent-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be6683",
  null
  
)

export default component.exports